export const BUILT_IN_MATERIAL_SHAPES = [
  { code: 1, label: '원형', active: true, displayOrder: 1, builtIn: true },
  { code: 2, label: '육각', active: true, displayOrder: 2, builtIn: true },
  { code: 3, label: '사각', active: true, displayOrder: 3, builtIn: true },
];

const numericCode = (value) => {
  if (typeof value === 'number' && Number.isInteger(value) && value >= 0 && value <= 0xFFFFFFFF) return value;
  if (typeof value === 'string' && /^\d+$/.test(value.trim())) {
    const code = Number(value.trim());
    if (Number.isInteger(code) && code >= 0 && code <= 0xFFFFFFFF) return code;
  }
  return null;
};

export const effectiveMaterialShapes = (stored = []) => {
  const byCode = new Map(BUILT_IN_MATERIAL_SHAPES.map((shape) => [shape.code, { ...shape }]));
  stored.forEach((shape) => {
    const code = numericCode(shape.code);
    if (code === null) return;
    byCode.set(code, {
      ...shape,
      code,
      builtIn: code === 1 || code === 2 || code === 3,
    });
  });
  return Array.from(byCode.values()).sort((left, right) => (
    Number(left.displayOrder) - Number(right.displayOrder) || left.code - right.code
  ));
};

export const resolveMaterialShape = (value, definitions = [], legacyLabel = '', allowBuiltInFallback = true) => {
  const code = numericCode(value);
  if (code !== null) {
    const tenantDefinition = definitions.find((shape) => Number(shape.code) === code);
    if (tenantDefinition?.label) return tenantDefinition.label;
    const builtIn = allowBuiltInFallback && BUILT_IN_MATERIAL_SHAPES.find((shape) => shape.code === code);
    if (builtIn) return builtIn.label;
    return `Unknown(${code})`;
  }
  const historical = String(value ?? legacyLabel ?? '').trim();
  return historical || '-';
};
